<template>
    <div class="table-action-buttons">
        <i v-if="canUpdate()"
            class="fa fa-edit fa-lg pointer"
            @click="edit"
            :title="uLang('app.edit_type', { type: lang('app.log') })"
        ></i>
        <i v-if="canDelete()"
            class="fa fa-trash fa-lg pointer"
            @click="remove"
            :title="uLang('app.delete_type', { type: lang('app.log') })"
        ></i>
    </div>
</template>

<script>
    import { DestroyAlert, SuccessAlert } from '~/Swals'

    import { mapGetters } from 'vuex'

    export default {
        name: 'Actions',
        props: ['data', 'index'],
        computed: mapGetters({
            user: 'authUser'
        }),
        data () {
            return {
                permissions: []
            }
        },
        created () {
            this.permissions = window.config.log_categories;
        },
        methods: {
            remove() {
                new DestroyAlert({ entity: this.lang('app.log') })
                    .show()
                    .then(async () => {
                        this.destroy()
                    });
            },

            edit() {
                if(this.data.entity_type == "App\\Models\\Organisation") {
                    this.$router.push({ name: 'admin.organisations.logs.edit', params: {
                        organisationId: this.data.entity_id, logId: this.data.id
                    }});
                } else {
                    this.$router.push({ name: 'admin.relations.logs.edit', params: {
                        relationId: this.data.entity_id, logId: this.data.id
                    }});
                }
            },

            async destroy() {
                await window.axios.delete(route('logs.destroy', { log: this.data.id }));
                new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', { entity: this.lang('app.log') })}).show();
                vue.$emit('reloadTable');
            },

            canDelete() {
                return this.hasPermissionTo('delete');
            },

            canUpdate() {
                return this.hasPermissionTo('update');
            },

            /**
             * Check if the user has the permission to e.g. delete the log
             * based on who created the log and the log category
             *
             * @param action
             * @returns {boolean}
             */
            hasPermissionTo(action) {
                return $hasRole('super_admin')
                    || (this.data.created_by === this.user.id);
            }
        },
    }
</script>

<style lang="scss" scoped>
</style>
